import React from 'react';

import AmbientSection from './components/AmbientSection';
import AreasSection from './components/AreasSection';
import CrossAreaSection from './components/CrossAreaSection';
import CTASection from './components/CTASection';
import FeaturesSection from './components/FeaturesSection';
import HeroSection from './components/HeroSection';
import LandingFooter from './components/LandingFooter';
import LandingNav from './components/LandingNav';

/**
 * Unauthenticated landing page.
 *
 * Section order carries the argument: an AI per area (AreasSection), the areas
 * correlating with each other (CrossAreaSection — the actual differentiator),
 * the breadth that makes correlation worth anything (FeaturesSection), then how
 * it runs unprompted (AmbientSection).
 */
const LandingPage: React.FC = () => {
  return (
    <div className="bg-muted dark:bg-background text-foreground min-h-screen">
      <LandingNav />
      <HeroSection />
      <AreasSection />
      <CrossAreaSection />
      <FeaturesSection />
      <AmbientSection />
      <CTASection />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
